export default __webpack_public_path__ + "static/media/disabled_bus_redencao_2.84110a75.png";